import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "9ycat6l2",
  dataset: "production",
});
